import {Component, OnInit} from '@angular/core';
import {ApiService} from '../service/api.service';

@Component({
  selector: 'main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
  }
}
